import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridYouthListModule } from '@app/shared/modules/app-grid-youth-list/app-grid-youth-list.module';
import { GridListModule } from '@app/shared/modules/grid-list/grid-list.module';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { YouthQuickSearchComponent } from './youth-quick-search.component';
@NgModule({
  declarations: [YouthQuickSearchComponent],
  imports: [CommonModule, PrimengModule, FormsModule, ReactiveFormsModule, GridListModule, GridYouthListModule],
  exports: [YouthQuickSearchComponent]
})
export class YouthQuickSearchModule { }